import React, { useCallback } from 'react';
import map from 'lodash/map';
import { useHistory } from 'react-router-dom';
import { withTranslation } from '../../../common/translation';
import { Link } from '../../../common/text';
import { ONGOING, EDIT, VP } from '../../../../constant/text';
import { MANAGE_VERSIONS_VPEDIT_PAGE } from '../../../../constant/route';
import { SET_VP_EDIT } from '../../../../constant/action';
import Loader from '../../../common/loader';
import { Table, Thead, Tbody, Tr, Th, Td } from '../../../common/table';
import { useStore } from '../../../../store';
import { getLanguageIdByCode } from '../../../util';

const VpList = props => {
    const { t, loader, list } = props;
    const { dispatch } = useStore();
    const setVpEdit = useCallback(payload => dispatch({ type: SET_VP_EDIT, payload }), [dispatch]);
    const history = useHistory();

    const editVp = vp => {
        const { version, languageCode, id: vpPackageId } = vp;
        setVpEdit({
            searchBy: VP,
            publicationStatus: ONGOING,
            version,
            languageId: getLanguageIdByCode(languageCode),
            vpPackageId,
            editType: EDIT
        });
        history.push(MANAGE_VERSIONS_VPEDIT_PAGE);
    };

    return (
        <div className="card loadable">
            <div className="title">{t('NEW_WORKING_VP_VERSIONS')}</div>
            <Table className={'striped-horizontally'}>
                <Thead>
                    <Tr>
                        <Th>{t('VERSION_NAME')}</Th>
                        <Th>{t('LANGUAGE')}</Th>
                        <Th>{t('CREATION_DATE')}</Th>
                        <Th>{t('REVISED_BY')}</Th>
                        <Th>{t('LAST_SAVED_VP')}</Th>
                        <Th>{t('LAST_SAVED')}</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {map(list, item => (
                        <Tr key={item.id}>
                            <Td><Link value={item.version} onClick={() => editVp(item)} /></Td>
                            <Td>{item.languageName}</Td>
                            <Td>{item.creationDate}</Td>
                            <Td>{item.lastSavedUsername}</Td>
                            <Td>{item.lastSavedVpheadersType}</Td>
                            <Td>{item.lastSavedDate}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
            {loader && <Loader />}
        </div>
    );
};

export default withTranslation()(VpList);
